import { useCallback } from "react";
import { useRolePermissionsCan } from "@Front/Stores/RolePermissionsStore";
import type { AppRulePermissionCanFn } from "@Front/Utils/permissionCanTypes";

export function useAppRulePermissionCan(): AppRulePermissionCanFn {
	const canFromStore = useRolePermissionsCan();
	return useCallback<AppRulePermissionCanFn>(
		(resource, action, scopedEntity) => canFromStore(resource, action, scopedEntity),
		[canFromStore],
	);
}
